import {AnteilseignerDetail, AppNameEnum, PersonenTypEnumLabels} from '@nachdigal';
import {ComponentHelper, FormBaseComponent, MappedStammdatenAnteilseigner, StammdatenService} from '@utils-lib';
import {Component, Input, OnInit} from '@angular/core';
import {FormBuilder} from '@angular/forms';
import {DatevMessageService} from '@datev/ngx-ui-components';
import {ActivatedRoute} from '@angular/router';
import {AnteilseignerPercentageService} from '../../../service';
import {cloneDeep} from 'lodash';

@Component({
    selector: 'common-ui-anteilseigner-form',
    templateUrl: './anteilseigner-form.component.html'
})
export class AnteilseignerFormComponent extends FormBaseComponent<AnteilseignerDetail> implements OnInit {

    @Input()
    stammdaten: MappedStammdatenAnteilseigner;
    @Input()
    public anteilseignerDetail: AnteilseignerDetail;
    public personenTypEnum = PersonenTypEnumLabels;
    public isKapGAus = false;

    constructor(private readonly formBuilder: FormBuilder,
                protected readonly messageService: DatevMessageService,
                protected readonly activatedRoute: ActivatedRoute,
                private readonly currentRoute: ActivatedRoute,
                private readonly stammdatenService: StammdatenService,
                private readonly anteilseignerPercentageService: AnteilseignerPercentageService) {
        super(messageService);
    }

    public ngOnInit(): void {
        const appEnum = ComponentHelper.getAppEnum(this.activatedRoute.snapshot);
        if (appEnum === AppNameEnum.FragebogenKapGAus) {
            this.isKapGAus = true;
        }
        this.data = this.anteilseignerDetail;
        if (this?.anteilseignerDetail?.stammdatenIndex !== undefined) {
            const stammdatenWithIndex = cloneDeep(
                this.activatedRoute.snapshot.data.stammdaten.unternehmen.anteilseigner[this.anteilseignerDetail.stammdatenIndex]
            );
            this.stammdaten = stammdatenWithIndex.value;
        }
        super.ngOnInit();
    }

    public onDataChanged(): void {
        this.anteilseignerPercentageService.onPercentageChange.emit();
    }

    public onPersonTypeChange(): void {
        this.onDataChanged();
        if (this.data.personenTyp === PersonenTypEnumLabels.NatPers) {
            this.data.juristischePerson = null;
        }
        if (this.data.personenTyp === PersonenTypEnumLabels.NNatPers) {
            this.data.natuerlichePerson = null;
        }
    }

    protected createForm(): void {
        if (this.data === undefined) {
            this.data = {};
        }
        this.form = this.formBuilder.group({});
        if (this.data.inlandsadresse === undefined && this.data.auslandsadresse === undefined) {
            this.stammdatenService.assignStammdatenIfDeterministic(this.getStammdatenMappingRules(), this.data);
        }
    }

    protected getStammdatenMappingRules(): Map<string, unknown> {
        return new Map<string, unknown | Array<unknown>>([
            ['inlandsadresse', this.stammdaten?.inlandsadressen],
            ['auslandsadresse', this.stammdaten?.auslandsadressen]
        ]);
    }
}
